import { WorkingScheduleFormType } from 'components/working-schedules/WorkingScheduleForm';
export const createWorkingScheduleInitialValues: Partial<WorkingScheduleFormType> = {};
